const floatWithComma = (val: number): string => {
  try {
    if (Number.isFinite(val)) {
      let temp = val.toString();
      temp = temp.replace(/\./g, ',');
      return temp;
    }
  } catch (_error) {
    return '0';
  }
  return '0';
};

const floatWithCommaFromString = (val: string): string => {
  try {
    if (val.length) {
      return val.replace(/\./g, ',');
    }
  } catch (_error) {
    return '0';
  }
  return '0';
};

export { floatWithComma, floatWithCommaFromString };
